import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'alt_intro';
export const route = 'alt_intro/[[...token]]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "alt_intro" */
/* webpackPrefetch: true */
'../components/AltIntroPage')));